import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import { Grid, Alert } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/pibs_logo_2.png";
import api from "../../services/api";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    borderRadius: 16,
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.5)",
  },
});

export default function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const validateAdmission = () => {
    setLoadData(true);
    setErrorMessage(""); // Clear any previous error

    if (username.length < 4) {
      setUsernameError(true);
      setLoadData(false);
      setErrorMessage("Admission number must be at least 4 characters long.");
    } else {
      setLoadData(true);
      setUsernameError(false);
      try {
        api({
          url: `/auth/student/validate-admission/${username}`,
          method: "POST",
        })
          .then((res) => {
            if (res.status === 200 && res.data.data.has_user_account) {
              setLoadData(false);
              console.log(res.data.data.message);
              setShowPassword(true);
            } else {
              navigate("/auth/account-otp?admissionNo=" + username);
            }
          })
          .catch((err) => {
            setLoadData(false);
            // Handle API error response
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              setErrorMessage(err.response.data.message);
            } else {
              setErrorMessage(
                "Failed to validate admission number. Please try again."
              );
            }
            console.log(err.message);
          });
      } catch (error) {
        setLoadData(false);
        setErrorMessage("An unexpected error occurred. Please try again.");
        console.log(error.message);
      }
    }
  };

  const handlePasswordSubmit = (e) => {
    const value = e.target.value;
    setPassword(value);
    e.preventDefault();
    setLoadData(true);
    if (value.trim() !== "" && value.length < 8) {
      setPasswordError(true);
      setLoadData(true);
    } else {
      setPasswordError(false);
      setLoadData(false);
    }
  };

  const handleLogin = () => {
    setLoadData(true);
    setErrorMessage(""); // Clear any previous error

    try {
      api({
        url: `/auth/student/login`,
        method: "POST",
        data: { username: username, password: password },
      })
        .then((res) => {
          if (res.status === 200) {
            setLoadData(false);
            sessionStorage.setItem("token", res.data.data.token);
            sessionStorage.setItem("id", res.data.data.user_id);
            sessionStorage.setItem("username", res.data.data.username);
            navigate("/");
          }
        })
        .catch((err) => {
          setLoadData(false);
          // Handle API error response
          if (err.response && err.response.data && err.response.data.message) {
            setErrorMessage(err.response.data.message);
          } else {
            setErrorMessage(
              "Login failed. Please check your credentials and try again."
            );
          }
          console.log(err);
        });
    } catch (error) {
      setLoadData(false);
      setErrorMessage("An unexpected error occurred. Please try again.");
      console.log(error);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center px-2 bg-gradient-to-b from-gray-100 to-gray-300">
      <Card
        className={classes.root}
        sx={{ minWidth: 300, maxWidth: 400 }}
        variant="outlined"
      >
        <CardMedia
          sx={{ height: 72, width: 72, margin: "auto", marginTop: "10px" }}
          component="img"
          image={logo}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div" align="center">
            PIBS Student Portal Login
          </Typography>
          <Grid container rowGap={3} marginTop={3}>
            {errorMessage && (
              <Alert severity="error" sx={{ width: "100%" }}>
                {errorMessage}
              </Alert>
            )}
            <TextField
              required
              fullWidth
              label="Admission Number"
              disabled={showPassword}
              onChange={(e) => {
                setUsername(e.target.value);
                e.preventDefault();
              }}
              size="small"
              error={usernameError}
            />
            <div hidden={!showPassword} style={{ width: "100%" }}>
              <TextField
                required
                fullWidth
                label="Password (at least 8 characters)"
                type="password"
                value={password}
                onChange={handlePasswordSubmit}
                size="small"
                error={passwordError}
                helperText="Please fill in your admission number and password."
              />
            </div>
          </Grid>
        </CardContent>
        <CardActions>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            rowGap={1}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <LoadingButton
                loading={loadData}
                hidden={!showPassword}
                size="medium"
                variant="contained"
                onClick={!showPassword ? validateAdmission : handleLogin}
                loadingIndicator="..."
              >
                {!showPassword ? <span>Proceed</span> : <span>Login</span>}
              </LoadingButton>
            </div>
            {showPassword && (
              <Button
                size="medium"
                variant="text"
                color="primary"
                component={Link}
                to={"/auth/reset-otp?admissionNo=" + username}
              >
                Forgot Password? Reset
              </Button>
            )}
          </Grid>
        </CardActions>
      </Card>
    </div>
  );
}
